import { FC } from 'react';
import styled, { DefaultTheme, createGlobalStyle } from 'styled-components';
import {
  WarningMessage, PasswordControl, PasswordControlProps, T0, T5, Form, Block, FormCol,
} from 'ia-react-core';

export const StyledFirstTitle = styled(T0)`  
  text-align: center;
  width: 560px;
  height: 84px;
  margin: 0 0px 36px 0px;  
`;

export const StyledTitle = styled(T0)`
  text-align: center;
  white-space: pre-wrap;
  text-shadow: ${({ theme }) => (theme as DefaultTheme & { awAuthentication?: { textShadow?: string } })?.awAuthentication?.textShadow || ''};
`;

export const StyledParagraph = styled.p`
  margin-top: 0px;
  margin: 0px;
  font-size: 14px;
`;

export const StyledInfo = styled(T5)`  
  margin-bottom: 0;
  padding-bottom: 24px;
  border-bottom: 1px solid #bbc2ca;  
  padding-right: 16px;
  padding-left: 16px;
`;

export const StyledFormStyle = styled(Form)`  
  width: 560px;
  height: 633px;
  margin: 36px 681px 151px 679px;
  padding: 36px 0;
  border-radius: 4px;
  box-shadow: 0 4px 16px 0 rgba(0, 38, 136, 0.08);
  background-color: white;
`;

export const StyledWarningMessageStyle = styled(WarningMessage)`  
  border:0;
  background-color:transparent;
  color:red;
`;

export const StyledPasswordControlStyle = styled<FC<PasswordControlProps>>(PasswordControl)`
  width: 496px !important;
  height: 40px !important;
  margin: 12px 0 0 !important;
  padding: 8px 12px !important;
  border-radius: 4px !important;
  border: solid 1px  !important;
  background-color: white !important;
`;

export const StyledBlockStyle = styled(Block)`
  width: 496px !important;
  height: 40px !important;
  margin: 12px 0 0 !important;
  padding: 8px 12px !important;
  border-radius: 4px !important;
  border: solid 1px  !important;
`;
export const StyledDiv = styled.div`
  margin: 0px auto 151px auto;
`;

export const StyledDivErrorMessage = styled.div`
  @media only screen and (max-width: 600px)
  {
    margin: 16px 16px 0px 16px;
  }  
`;

export const StyledPwdInfoStyledFormCol = styled(FormCol)`
  padding-left: 0px;
  padding-right: 0px;
`;

export const StyledConfirmButtonActionBarWrapper = styled.div`
  margin-top:-24px !important;
`;

export const WidgetGlobalStyles = createGlobalStyle`
  .MarginTop36
  {
    margin-top: 36px;
  }

  button[data-testid="PasswordInputVisibilityButton"] {
    color: rgb(32, 98, 212)
  }
`;
